export default __webpack_public_path__ + "static/media/web-dev.a5174ccc.png";